export default "__VITE_ASSET__GNbONsls__"